"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyRequestBindOperation = void 0;
exports.verifyRequestBindOperation = {
    method: 'POST',
    name: 'verifyRequestBind',
    id: 'verifyRequestBind',
    groupName: 'evm',
    urlPathPattern: '/bind/request/verify',
    bodyParamNames: ['verifications'],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams() {
    return {};
}
function getRequestBody(request) {
    return {
        verifications: request.verifications,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return {
        verifications: request.verifications,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        verifications: jsonRequest.verifications,
    };
}
//# sourceMappingURL=verifyRequestBindOperation.js.map